export const getters = {
    getCompras: (state) => state.data,
    getCompra: (state) => state.compra,
    getStatus: (state) => state.status,
    getTipos: (state) => state.tipos,
    getProdutosServicos: (state) => state.produtos_servicos,
    getDocumentos: (state) => state.documentos,
    getFiltroSetores: (state) => state.filtroSetores
};